import useCmsQuery from './useCmsQuery.tsx';
import { getWelcomeOffers, PreferredWo, TWelcomeOffer } from '../../cms';
import useMarketInfo from '../../hooks/useMarketInfo.tsx';

type UseWelcomeOffersResult = {
  offers: TWelcomeOffer[];
  loading: boolean;
  error?: Error;
};

const useWelcomeOffers = (preferred?: PreferredWo): UseWelcomeOffersResult => {
  const { market, language } = useMarketInfo();

  const affiliateWelcomeOfferName = sessionStorage.getItem('fabric:registration:affiliateWelcomeOffer');

  const { data, loading, error } = useCmsQuery(
    () => getWelcomeOffers({ market, language, affiliateName: affiliateWelcomeOfferName, preferred }),
    [market, language, preferred, affiliateWelcomeOfferName],
  );

  return { offers: data ?? [], loading, error };
};

export default useWelcomeOffers;
